var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 56,
    viewBox: "0 0 129 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 55,
    height: 35,
    rx: 0.5,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 35 55)",
    fill: "#EDF3FF",
    fillOpacity: 0.2,
    stroke: "#4680FF",
    strokeDasharray: "1 1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.18519,
    height: 28,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 31.9971 8.3335)",
    fill: "#4680FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.18519,
    height: 28,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 31.9971 27.0371)",
    fill: "#4680FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 28,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 32 42)",
    fill: "#4680FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 9.37061,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 9.37061)",
    fill: "#7EA6FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 28.0742,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 28.0742)",
    fill: "#7EA6FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 11.4443,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 11.4443)",
    fill: "#7EA6FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 30.1479,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 30.1479)",
    fill: "#7EA6FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.03704,
    height: 28,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 31.9971 14.5557)",
    fill: "#7EA6FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.03704,
    height: 28,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 31.9971 33.2593)",
    fill: "#7EA6FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.03704,
    height: 28,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 31.9971 18.7036)",
    fill: "#7EA6FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 15.5928,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 15.5928)",
    fill: "#7EA6FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 34.2964,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 34.2964)",
    fill: "#7EA6FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 19.7407,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 19.7407)",
    fill: "#7EA6FF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 43.5186,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 43.5186)",
    fill: "#7EA6FF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 45.5557,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 45.5557)",
    fill: "#7EA6FF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 47.5928,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 47.5928)",
    fill: "#7EA6FF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 49.6299,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 49.6299)",
    fill: "#7EA6FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 51.667,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 51.667)",
    fill: "#7EA6FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 42,
    height: 87,
    rx: 1.5,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 127.997 55)",
    fill: "#EDF3FF",
    fillOpacity: 0.4,
    stroke: "#7EA6FF",
    strokeDasharray: "1 1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 8.99999,
    height: 87,
    rx: 0.5,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 127.997 9)",
    fill: "#EDF3FF",
    fillOpacity: 0.4,
    stroke: "#7EA6FF",
    strokeDasharray: "1 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaption);
export default __webpack_public_path__ + "static/media/caption.18f89bbc6fc4f5f965aca2bc3d13fd6d.svg";
export { ForwardRef as ReactComponent };